import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-222484be")

_pushScopeId("data-v-222484be")
const _hoisted_1 = { class: "managerDetail" }
const _hoisted_2 = { class: "p-grid p-m-0 p-fluid" }
const _hoisted_3 = { class: "p-col-9" }
const _hoisted_4 = { class: "p-grid" }
const _hoisted_5 = { class: "p-col-3" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  class: "kn-material-input-label",
  for: "label"
}
const _hoisted_8 = { class: "p-col-3" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  class: "kn-material-input-label",
  for: "name"
}
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  class: "kn-material-input-label",
  for: "type"
}
const _hoisted_13 = {
  key: 0,
  class: "p-col-3"
}
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = {
  class: "kn-material-input-label",
  for: "outputType"
}
const _hoisted_16 = { class: "p-col-12" }
const _hoisted_17 = { class: "p-float-label" }
const _hoisted_18 = {
  class: "kn-material-input-label",
  for: "description"
}
const _hoisted_19 = { class: "p-col-12 kn-truncated" }
const _hoisted_20 = {
  class: "kn-material-input-label",
  for: "tags"
}
const _hoisted_21 = { id: "username1-help" }
const _hoisted_22 = { class: "p-col-3 kn-height-full" }
const _hoisted_23 = { for: "inputImage" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_25 = { class: "imageContainer p-d-flex p-jc-center p-ai-center" }
const _hoisted_26 = {
  key: 0,
  class: "far fa-image fa-5x icon"
}
const _hoisted_27 = {
  key: 0,
  class: "p-grid p-m-2 flex"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_29 = { style: {"text-transform":"uppercase"} }
const _hoisted_30 = {
  key: 1,
  class: "p-grid p-m-0 flex"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Chips = _resolveComponent("Chips")
  const _component_Card = _resolveComponent("Card")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0" }, {
      start: _withId(() => [
        _createTextVNode(" Template " + _toDisplayString(_ctx.template.label), 1)
      ]),
      end: _withId(() => [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-download",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: !_ctx.template.id,
          onClick: _ctx.downloadTemplate
        }, null, 8, ["disabled", "onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.download'),
            void 0,
            { bottom: true }
          ]
        ]),
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.isSaveButtonDisabled,
          onClick: _ctx.saveTemplate
        }, null, 8, ["disabled", "onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.save'),
            void 0,
            { bottom: true }
          ]
        ]),
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeTemplateConfirm()))
        }, null, 512), [
          [
            _directive_tooltip,
            _ctx.$t('common.close'),
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Card, null, {
            content: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", _hoisted_6, [
                    _createVNode(_component_InputText, {
                      id: "label",
                      modelValue: _ctx.v$.template.label.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.template.label.$model = $event)),
                      class: "kn-material-input",
                      type: "text",
                      onChange: _ctx.setDirty
                    }, null, 8, ["modelValue", "onChange"]),
                    _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.label')), 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    "v-comp": _ctx.v$.template.label,
                    "additional-translate-params": { fieldName: _ctx.$t('common.label') }
                  }, null, 8, ["v-comp", "additional-translate-params"])
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("span", _hoisted_9, [
                    _createVNode(_component_InputText, {
                      id: "name",
                      modelValue: _ctx.v$.template.name.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.template.name.$model = $event)),
                      class: "kn-material-input",
                      type: "text",
                      onChange: _ctx.setDirty
                    }, null, 8, ["modelValue", "onChange"]),
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.name')), 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    "v-comp": _ctx.v$.template.name,
                    "additional-translate-params": { fieldName: _ctx.$t('common.name') }
                  }, null, 8, ["v-comp", "additional-translate-params"])
                ]),
                _createVNode("div", {
                  class: _ctx.template.type === 'python' ? 'p-col-3' : 'p-col-6'
                }, [
                  _createVNode("span", _hoisted_11, [
                    _createVNode(_component_Dropdown, {
                      id: "type",
                      modelValue: _ctx.template.type,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.template.type = $event)),
                      class: "kn-material-input",
                      options: _ctx.galleryDescriptor.types,
                      "option-label": "name",
                      "option-value": "value",
                      onChange: _ctx.setDirty
                    }, null, 8, ["modelValue", "options", "onChange"]),
                    _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.type')), 1)
                  ])
                ], 2),
                (_ctx.template.type === 'python')
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("span", _hoisted_14, [
                        _createVNode(_component_Dropdown, {
                          id: "outputType",
                          modelValue: _ctx.v$.template.outputType.$model,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.template.outputType.$model = $event)),
                          class: "kn-material-input",
                          options: _ctx.galleryDescriptor.outputTypes,
                          "option-label": "name",
                          "option-value": "value",
                          onChange: _ctx.setDirty
                        }, null, 8, ["modelValue", "options", "onChange"]),
                        _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('managers.widgetGallery.outputType')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_16, [
                  _createVNode("span", _hoisted_17, [
                    _createVNode(_component_Textarea, {
                      id: "description",
                      modelValue: _ctx.v$.template.description.$model,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.template.description.$model = $event)),
                      class: "kn-material-input",
                      style: {"resize":"none"},
                      rows: "3",
                      onChange: _ctx.setDirty
                    }, null, 8, ["modelValue", "onChange"]),
                    _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('common.description')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode("span", {
                    class: "p-float-label kn-material-input",
                    title: _ctx.$t('managers.widgetGallery.tags.availableCharacters')
                  }, [
                    _createVNode(_component_Chips, {
                      modelValue: _ctx.v$.template.tags.$model,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.template.tags.$model = $event)),
                      "allow-duplicate": false,
                      onAdd: _ctx.setDirty,
                      onRemove: _ctx.setDirty
                    }, null, 8, ["modelValue", "onAdd", "onRemove"]),
                    _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('common.tags')), 1)
                  ], 8, ["title"]),
                  _createVNode("small", _hoisted_21, _toDisplayString(_ctx.$t('managers.widgetGallery.tags.availableCharacters')), 1)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_Card, { class: "imageUploader" }, {
            title: _withId(() => [
              _createVNode("input", {
                id: "inputImage",
                type: "file",
                accept: "image/png, image/jpeg",
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
              }, null, 32),
              _withDirectives(_createVNode("label", _hoisted_23, [
                _hoisted_24
              ], 512), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.upload'),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            content: _withId(() => [
              _createVNode("div", _hoisted_25, [
                (!_ctx.template.image)
                  ? (_openBlock(), _createBlock("i", _hoisted_26))
                  : _createCommentVNode("", true),
                (_ctx.template.image)
                  ? (_openBlock(), _createBlock("img", {
                      key: 1,
                      src: _ctx.template.image,
                      height: "100%",
                      class: "kn-no-select"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.template.type && _ctx.windowWidth < _ctx.windowWidthBreakPoint)
        ? (_openBlock(), _createBlock("div", _hoisted_27, [
            _createVNode(_component_TabView, {
              class: "tabview-custom",
              style: {"width":"100%"}
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.galleryDescriptor.allowedEditors[_ctx.template.type], (allowedEditor, index) => {
                  return (_openBlock(), _createBlock(_component_TabPanel, { key: allowedEditor }, {
                    header: _withId(() => [
                      _createVNode("i", {
                        class: ['icon', _ctx.galleryDescriptor.editor[allowedEditor].icon]
                      }, null, 2),
                      _hoisted_28,
                      _createVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('common.codingLanguages.' + allowedEditor)), 1)
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_VCodeMirror, {
                        ref: 'editor_' + index,
                        class: "flex",
                        value: _ctx.template.code[allowedEditor],
                        "onUpdate:value": [($event: any) => (_ctx.template.code[allowedEditor] = $event), _ctx.onCmCodeChange],
                        options: _ctx.galleryDescriptor.options[allowedEditor]
                      }, null, 8, ["value", "onUpdate:value", "options"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.template.type && _ctx.windowWidth >= _ctx.windowWidthBreakPoint)
        ? (_openBlock(), _createBlock("div", _hoisted_30, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.galleryDescriptor.allowedEditors[_ctx.template.type], (allowedEditor) => {
              return (_openBlock(), _createBlock("div", {
                key: allowedEditor,
                class: ["multiViewer", 'p-col-' + 12 / _ctx.galleryDescriptor.allowedEditors[_ctx.template.type].length]
              }, [
                _createVNode("h4", null, [
                  _createVNode("i", {
                    class: ['icon', _ctx.galleryDescriptor.editor[allowedEditor].icon]
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.codingLanguages.' + allowedEditor)), 1)
                ]),
                _createVNode(_component_VCodeMirror, {
                  class: "flex",
                  value: _ctx.template.code[allowedEditor],
                  "onUpdate:value": [($event: any) => (_ctx.template.code[allowedEditor] = $event), _ctx.onCmCodeChange],
                  options: _ctx.galleryDescriptor.options[allowedEditor]
                }, null, 8, ["value", "onUpdate:value", "options"])
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
})